<template>
  <centered-content :logo="logo">
    <v-col cols="12" sm="8" md="6">
      <v-form @submit.prevent="$emit('submit')">
        <v-card :loading="loading ? 'accent' : false">
          <v-toolbar dark flat class="primary">
            <v-toolbar-title>{{ title }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <template v-for="(err, i) in errors">
              <v-alert border="left" :icon="errorIcon" dark color="error" :key="'err'+i">{{err}}</v-alert>
            </template>
            <slot>You should probably put something here</slot>
          </v-card-text>
          <v-card-actions>
            <slot name="actions"></slot>
            <v-spacer />
            <v-btn type="submit" :disabled="disabled || loading" color="primary">{{ goAction }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-col>
  </centered-content>
</template>

<script>
import CenteredContent from '@/components/CenteredContent'
import { mdiAlertCircle } from '@mdi/js'

export default {
  name: 'Form',
  components: {
    CenteredContent
  },
  computed: {
    errorIcon () {
      return mdiAlertCircle
    }
  },
  props: {
    logo: String,
    title: String,
    loading: Boolean,
    disabled: Boolean,
    errors: {
      type: Array,
      default: () => []
    },
    goAction: {
      type: String,
      default: 'Submit'
    }
  }
}
</script>

<style scoped>
.form-logo {
  width: 100%;
}
</style>
